export default {

    bind (el, bindings, vnode) {
        const me = vnode.data.directives.find(item => item.name === 'same').def;
        window.addEventListener("resize", () => {
            me.calcHeight(el)
        });
        setTimeout(() => {
            me.calcHeight(el);
        });
    },

    calcHeight(el) {
        setTimeout(() => {
            const heights = Object.keys(el.children).map(key => el.children[key].clientHeight);
            const maxHeight = Math.max(...heights);

            Object.keys(el.children).forEach(key => {
                el.children[key].style.minHeight = maxHeight + 'px';
            });
        }, 250);
    },

    unbind(el, bindings, vnode) {
        const me = vnode.data.directives.find(item => item.name === 'same').def;
        window.removeEventListener("resize", () => me.calcHeight(el));
    }

}
